import { httpService } from 'core-utilities';

// creates Autocomplete URL to call
function createURLConfig(prefix, categoryNum, endpoint, limit) {
  const categoryMapping = {
    6: 'model',
    8: 'image',
    9: 'audio',
    14: 'video',
    10: 'mesh',
    7: 'plugin'
  };
  const category = categoryMapping[categoryNum];
  let baseURL = endpoint;
  if (!limit) {
    limit = 6;
  }
  if (!prefix || !prefix.trim()) {
    throw 'Prefix has no valid characters, autocomplete request could not be sent';
  }
  baseURL += `?prefix=${prefix}&limit=${limit}`;
  if (category) {
    baseURL += `&cat=${category}`;
  } else {
    throw `Number: ${categoryNum} could not be mapped to a valid category, autocomplete request could not be sent`;
  }
  return {
    withCredentials: true,
    url: baseURL
  };
}

// Changes JSON data from endpoint into array of autocomplete options
function autocompleteJSONToArray(json) {
  try {
    const autocompleteArray = [];
    const prefix = json.Args.Prefix;
    const dataList = json.Data;
    dataList.forEach(function (item) {
      autocompleteArray.push(item.Query);
    });
    const info = { prefix, suggestions: autocompleteArray };
    return info;
  } catch (error) {
    throw error;
  }
}

// Requests autocomplete data for the user prefix from the API
function getAutocompleteData(prefix, categoryElement, endpoint, limit) {
  const promise = new Promise((resolve, reject) => {
    const urlConfig = createURLConfig(prefix, categoryElement.value, endpoint, limit);
    const params = {};
    httpService
      .get(urlConfig, params)
      .then(response => {
        const suggestions = autocompleteJSONToArray(response.data);
        resolve(suggestions);
      })
      .catch(error => {
        reject(`Something went wrong getting autocomplete suggestions: ${error}`);
      });
  });
  return promise;
}

export { getAutocompleteData };
